var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 133,
    viewBox: "0 0 200 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 79.4H12.4V69.6L40.6 24.2H52.2V71H62.2V79.4H52.2V95H42.6V79.4ZM42.6 35.6H42.4L20.8 71H42.6V35.6Z",
    fill: "#42526D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175 36.2L162 48.2L156.4 41.5L176.1 25.2H184.6V96H175V36.2Z",
    fill: "#42526D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11119_126223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.148 58.4982C145.763 51.1104 143.211 44.0032 138.814 38.0755C134.418 32.1479 128.374 27.6659 121.448 25.1964C114.521 22.7269 107.022 22.3808 99.9004 24.2018C92.7784 26.0229 86.3527 29.9293 81.4358 35.4271C76.519 40.9248 73.3318 47.7671 72.2774 55.0885C71.223 62.4099 72.3487 69.8817 75.5122 76.5591C78.6756 83.2364 83.7347 88.8193 90.0498 92.6019C96.3648 96.3844 103.652 98.1967 110.99 97.8095C120.827 97.2825 130.055 92.8468 136.646 85.4763C143.238 78.1058 146.655 68.403 146.148 58.4982ZM107.412 29.0788C113.324 28.7611 119.204 30.1445 124.363 33.0672C129.523 35.99 133.749 40.3312 136.548 45.5834C139.347 50.8355 140.603 56.7814 140.169 62.7257C139.735 68.67 137.629 74.3671 134.097 79.1507L87.96 37.3267C93.289 32.3755 100.171 29.4576 107.412 29.0788ZM77.8802 62.1002C77.4975 54.8098 79.6605 47.6143 83.9943 41.761L130.131 83.585C125.775 87.6213 120.368 90.3255 114.541 91.3814C108.715 92.4374 102.71 91.8014 97.2292 89.5478C91.7485 87.2942 87.0183 83.5162 83.5919 78.6556C80.1654 73.795 78.1843 68.0527 77.8802 62.1002Z",
    fill: "#E2344A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11119_126223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.8085,
    height: 74.3069,
    fill: "white",
    transform: "matrix(0.0519841 0.998648 -0.998611 0.0526902 144.203 21.1445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.41e9b0f66657e4bde5424ba223962c4e.svg";
export { ForwardRef as ReactComponent };